import React, {useState, useEffect, useCallback} from "react";
import {BottomScrollListener} from "react-bottom-scroll-listener";
import $ from "jquery";
import DatePicker from "react-datepicker";
import {debounce} from "lodash";
import {
  setLocaleInDataPiker,
  MEDIUM_DEBOUNCE_TIME,
  enterDownHandler,
  buildEditableSelect,
  pluralize,
  parseUserGeneralities,
  isDefined,
  parseHomePickUpFavoriteHour,
  parseHomePickUpFavoriteDay,
  DEFAULT_PER_PAGE_PARAM,
  checkHtmlElement
} from "../../utils/utils";
import I18n from 'i18n.js.erb'
import AlertPopup from "./AlertPopup";
import SubmissionListHomePikcUpPopup from "./SubmissionListHomePikcUpPopup";
import {parseSubmissionListState} from "../../utils/utils";
import ErrorModal from "./ErrorModal";
import SuccessModal from "./SuccessModal";
import SuccessFlashMessage from "./SuccessFlashMessage";
import PDFGenerator from "./PDFGenerator";
import SubmissionListsList from "./SubmissionListsList";
import "select2";


export const Expander = ({ expandAll, handleExpandAll }) => {

  return <div className="d-flex justify-content-end justify-content-sm-center align-items-center">
    <div className="d-flex justify-content-end justify-content-sm-center align-items-center minW-125px blue-label cursor-pointer m-auto"
         onClick={handleExpandAll}
    >
      <img src={window.location.origin + `/images/icons/blue/arrow-${expandAll ? 'up' : 'down'}.svg`}
           alt="" width="15" height="15" className="mr-2"
      />
      <p className="my-0">
        {I18n.t(`js.indexSubmissionListsPage.${expandAll ? 'compact' : 'expand'}All`)}
      </p>
    </div>
  </div>
}




const IndexSubmissionLists = ({
    initial_submission_lists,
    sorting_options,
    isMiddleman,
    isSuperMiddleman,
    states,
    users,
    subMiddlemen,
    grader_companies,
    currentUserGenerality,
    homePickUpDates,
    userId,
    companyPoint
  }) => {

  const initialSubmissionLists = JSON.parse(initial_submission_lists);
  const graderCompanies = JSON.parse(grader_companies);
  const [initCompleted, setInitCompleted] = useState(false)
  const [submissionLists, setSubmissionLists] = useState([]);
  const [submissionListsCount, setSubmissionListsCount] = useState(0);
  const initialFilters = {
    number: null, user_id: null, middleman_business_name: null, title: null, grader_company_id: null, state: null,
    from_confirmed_at: null, to_confirmed_at: null, serial_number: null, sort_by: null, sorting_direction: 'desc'
  }
  const [expandAll, setExpandAll] = useState(null)
  const [viewMode, setViewMode] = useState(null)
  const [changeViewMode, setChangeViewMode] = useState(false);
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [filters, setFilters] = useState(initialFilters)
  const [page, setPage] = useState(1);
  const [hasLoadedAllSubmissionLists, setHasLoadedAllSubmissionLists] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [filtersEnabled, setFiltersEnabled] = useState(window.innerWidth > 768);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [submissionListToDelete, setSubmissionListToDelete] = useState(null);
  const [showSuccessFlashMessage, setShowSuccessFlashMessage] = useState(false)
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [submissionListsToRequestPickUp, setSubmissionListsToRequestPickUp] = useState([]);
  const [productsCountToRequestPickUp, setProductsCountToRequestPickUp] = useState(0);
  const [companyToRequestPickUp, setCompanyToRequestPickUp] = useState(null);
  const [graderCompanyShipmentAddress, setGraderCompanyShipmentAddress] = useState(null);
  const [showPickUpRequestPopup, setShowPickUpRequestPopup] = useState(false);
  const [submissionListToSend, setSubmissionListToSend] = useState(null);
  const [statesForFilters, setStatesForFilters] = useState(states)
  const [homePickUpFavoriteDay, setHomePickUpFavoriteDay] = useState(null)
  const [homePickUpFavoriteHour, setHomePickUpFavoriteHour] = useState(null)
  const [checkAll, setCheckAll] = useState(false);
  const [showPickUpSuccessPopup, setShowPickUpSuccessPopup] = useState(false);
  const [ submissionListsAnimationDivider, setSubmissionListsAnimationDivider ] = useState(Number.MAX_SAFE_INTEGER);

  // console.log('submissionLists: ', submissionLists);

  useEffect(() => {
    if (initCompleted && submissionLists.length === 0) {
      getSubmissionLists()
    }
  }, [submissionLists]);

  useEffect(() => {
    if (!initCompleted) {
      setInitCompleted(true)
      appendSubmissionLists(initialSubmissionLists.submission_lists)
      setSubmissionListsCount(initialSubmissionLists.submission_lists_count)

      enterDownHandler(setFiltersEnabled)
    }
  }, []);

  useEffect(() => {
    if (initCompleted) {
      debouncedUpdateFilters();
      return debouncedUpdateFilters.cancel;
    }
  }, [filters.number, filters.title, filters.serial_number, debouncedUpdateFilters]);

  useEffect(() => {
    if (filters.user_id)
      setTimeout(() => { $("span.select2-selection.select2-selection--single[aria-labelledby=select2-user_id-container]").addClass("selected-label"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("selected-label");

    if (filters.middleman_business_name)
      setTimeout(() => { $("span.select2-selection.select2-selection--single[aria-labelledby=select2-middleman_business_name-container]").addClass("selected-label"); }, 50)
    else
      $(".select2-selection.select2-selection--single").removeClass("selected-label");
  }, [filters]);

  useEffect(() => {
    buildEditableSelect(handleChangeFilterValue)
  }, [ filtersEnabled, filters ]);


  useEffect(() => {
    if (viewMode)
      setChangeViewMode(true);
  }, [ viewMode ]);


  useEffect(() => {
    if (changeViewMode)
      setChangeViewMode(false);
  }, [ changeViewMode ]);



  // Funzione che gestisce il settaggio di un nuovo filtro da parte dell'utente sull'interfaccia grafica
  const handleChangeFilterValue = (e) => {
    getSubmissionListsByMatchingFilters(e.target.id, e.target.value)
  }


  // Funzione che esegue il parsing dell'endpoint del server da cui il componente ottiene i dati da renderizzare a video
  const parseSubmissionListsUrl = (format, newPage, perPage) => {
    let url = `/submission_lists.json?page=${page}&per_page=${DEFAULT_PER_PAGE_PARAM}`
    if (perPage)
      url +=`&per_page=${perPage}`
    if (userId)
      url += `&user_owner_id=${userId}`
    Object.entries(filters).forEach(([fieldName, fieldValue]) => {
      if (fieldValue !== null)
        url += `&${fieldName}=${fieldValue}`
      else {
        if (fieldName === 'sort_by')
          url += `&${fieldName}=confirmed_at`
        if (fieldName === 'sorting_direction')
          url += `&${fieldName}=desc`
      }
    })
    return url;
  }


  // Funzione che permette di ottenere dal server nuove submission lists da renderizzare sull'interfaccia grafica
  const getSubmissionLists = () => {
    if (!hasLoadedAllSubmissionLists) {
      setSubmissionListsAnimationDivider(DEFAULT_PER_PAGE_PARAM);
      fetch(parseSubmissionListsUrl(), {
        method: 'GET'
      })
        .then(response => response.json())
        .then((data) => {
          setLoading(false);
          setLoadingMore(false);
          if (expandAll) {
            const newSubmissionLists = data.submission_lists.map(s => {
              const newSubmissionList = { ...s };
              newSubmissionList['display_content'] = expandAll;
              return newSubmissionList;
            })
            appendSubmissionLists(newSubmissionLists);
          } else {
            appendSubmissionLists(data.submission_lists);
          }
          setSubmissionListsCount(data.submission_lists_count)
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che permette di concatenare nuove submission lists ottenute del server all'array che contiene tutti le
  // submission lists da mostrare sull'interfaccia grafica all'utente
  const appendSubmissionLists = (newSubmissionLists) => {
    setSubmissionLists(submissionLists.concat(newSubmissionLists));
    setPage(page + 1);
    if (newSubmissionLists.length < DEFAULT_PER_PAGE_PARAM)
      setHasLoadedAllSubmissionLists(true)
  }


  // Funzione che permette di ottenere dal server le submission lists dell'utente che matchano con i filtri
  // di ricerca da lui specificati sull'interfaccia grafica
  const getSubmissionListsByMatchingFilters = (filter, value) => {
    const newFilters = {...filters}
    newFilters[filter] = (filter === 'from_confirmed_at' || filter === 'to_confirmed_at') && value ? value.getFullYear() + '-' + (value.getMonth() + 1) + '-' + value.getDate() : value;
    updateFilters(newFilters)
  }


  // Funzione che aggiorna i filtri di ricerca delle submission lists specificati dall'utente sull'interfaccia grafica
  // e rilancia la ricerca sulle submission lists che matchano con i nuovi filtri specificati
  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    setLoading(true);
    setPage(1);
    setHasLoadedAllSubmissionLists(false);
    setSubmissionLists([]);
    resetHomePickUpData();

    setCheckAll(false);
    checkHtmlElement(document, 'select_all_submission_lists', false);
  }


  //Funzione che esegue l'update debouncato del filtro di ricerca
  // delle submission lists per titolo o per numero o per seriale
  const debouncedUpdateFilters = useCallback(
    debounce(() => updateFilters(filters), MEDIUM_DEBOUNCE_TIME),
    [filters.number, filters.title, filters.serial_number]
  );


  //Funzione che setta il nuovo filtro di ricerca delle submission lists per titolo o per id
  function onChangeDebouncedFilterHandler(key, value) {
    const newFilters = {...filters}
    newFilters[key] = value;
    setFilters(newFilters)
  }


  //Funzione che permette all'utente di eliminare una specifica submission list in stato di draft
  const onDeleteHandler = () => {
    if (submissionListToDelete.state === 'draft' && submissionListToDelete.can_be_edited_by_user) {
      const url = `/submission_lists/${submissionListToDelete.id}`;

      fetch(url, {
        method: "DELETE"
      })
        .then((response) => {
          console.log("response: ", response);
        })
        .then((data) => {
          let newSubmissionLists = submissionLists.filter((submissionList) => submissionList.id !== submissionListToDelete.id);
          setSubmissionLists(newSubmissionLists);
          setSubmissionListsCount(submissionListsCount - 1);
          setShowSuccessFlashMessage(true);
          setSubmissionListToDelete(null);
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }

  //Funzione che apre il popup di conferma eliminazione della submission list
  const openDeletePopup = (submissionList) => {
    setSubmissionListToDelete(submissionList);
    setShowDeletePopup(true);
  }


  // Funzione che aggiunge / rimuove una nuova submission list confermata alla lista di quelle per le quali
  // l'aggregatore sta per chiedere il ritiro a domicilio alla casa di gradazione
  const addSubmissionListToRequestPickUp = (submissionList) => {
    if (isMiddleman && enableHomePickUpCollect() && submissionList.enable_pick_up_request && submissionList.state === 'confirmed') {
      handleChangeSubmissionListParams({ ...submissionList, checked: !submissionList.checked });
      if (!submissionListsToRequestPickUp.includes(submissionList.id)) {
        setSubmissionListsToRequestPickUp([...submissionListsToRequestPickUp, submissionList.id]);
        setCompanyToRequestPickUp(submissionList.grader_company);
        setGraderCompanyShipmentAddress(submissionList.grader_company_shipment_address);
        setProductsCountToRequestPickUp(productsCountToRequestPickUp + submissionList.items_count);
      }
      else {
        const newSubmissionListsToRequestPickUp = submissionListsToRequestPickUp.filter((id) => id != submissionList.id);
        setSubmissionListsToRequestPickUp(newSubmissionListsToRequestPickUp);
        setProductsCountToRequestPickUp(productsCountToRequestPickUp - submissionList.items_count);
        if (newSubmissionListsToRequestPickUp.length === 0) {
          setCompanyToRequestPickUp(null);
          setGraderCompanyShipmentAddress(null);
        }
      }
    }
  }


  // Funzione che aggiunge / rimuove tutte le submission lists confermate alla lista di quelle per le quali
  // l'aggregatore sta per chiedere il ritiro a domicilio alla casa di gradazione
  const handleSelectAllSubmissionLists = (check) => {
    if (isMiddleman && enableHomePickUpCollect()) {
      let selectedSubmissionListsIds = [];
      let productsCount = 0;
      let company = null;
      let companyShipmentAddress = null;

      const newsSubmissionLists = submissionLists.map(s => {
        const newSubmissionList = { ...s };
        if (s.enable_pick_up_request && s.state === 'confirmed') {
          if (check) {
            selectedSubmissionListsIds.push(s.id);
            productsCount += s.items_count;
            company = s.grader_company;
            companyShipmentAddress = s.grader_company_shipment_address ? s.grader_company_shipment_address : companyShipmentAddress;
          }
          newSubmissionList['checked'] = check;
        }
        return newSubmissionList;
      });

      setCheckAll(check);
      setSubmissionListsToRequestPickUp(selectedSubmissionListsIds);
      setProductsCountToRequestPickUp(productsCount);
      setCompanyToRequestPickUp(company);
      setGraderCompanyShipmentAddress(companyShipmentAddress);
      setSubmissionLists(newsSubmissionLists);
    }
  }



  // Funzione che controlla se nell'interfaccia grafica ci sia almeno 
  // una submission list confermata ma non ancora selezionata dall'aggregatore
  const checkNotCheckedSubmissionLists = () => {
    return submissionLists.filter(s => s.enable_pick_up_request && s.state === 'confirmed' && !s.checked)?.length > 0
  }


  // Funzione che resetta i dati per la richiesta di ritiro a domicilio aggregato
  // di più submission lists da parte dell'utente gradatore
  const resetHomePickUpData = () => {
    setSubmissionListsToRequestPickUp([]);
    setCompanyToRequestPickUp(null);
    setGraderCompanyShipmentAddress(null);
    setProductsCountToRequestPickUp(0);
    setCheckAll(false);
    setHomePickUpFavoriteDay(null);
    setHomePickUpFavoriteHour(null);
    setHomePickUpFavoriteDay(null);
    setHomePickUpFavoriteHour(null);
    setShowPickUpSuccessPopup(false);
  }


  //Funzione che permette all'aggregatore di chiedere alla casa di gradazione il servizio di ritiro aggregato
  // per più submission lists
  const onShipmentManagementHandler = (homePickUpFavoriteDay, homePickUpFavoriteHour) => {
    if (isMiddleman) {
      const url = `/submission_lists/middlemen/manage_shipment`;
      setShowPickUpRequestPopup(false);

      let state = null;
      let submissionListIds = null;
      const body = {};
      if (submissionListToSend) {
        submissionListIds = [submissionListToSend.id]
        body['submission_list_ids'] = submissionListIds;
        body['initial_state'] = submissionListToSend.state;
        body['state'] = 'sent';
        state = 'sent';
      } else {
        submissionListIds = submissionListsToRequestPickUp;
        body['submission_list_ids'] = submissionListIds;
        body['initial_state'] = 'confirmed';
        state = productsCountToRequestPickUp >= companyToRequestPickUp.shipping_discount_products_threshold ? 'pick_up_requested' : 'sent';
        body['state'] = state;
      }

      if (homePickUpFavoriteDay)
        body['home_pick_up_favorite_day'] = homePickUpFavoriteDay;

      if (homePickUpFavoriteHour)
        body['home_pick_up_favorite_hour'] = homePickUpFavoriteHour;

      setSubmissionListToSend(null);

      fetch(url, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((res) => {
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json()
        })
        .then((data) => {
          let newSubmissionLists = submissionLists.map((s) => {
            const newSubmissionList = {...s, checked: false}
            if (submissionListIds.includes(s.id)){
              newSubmissionList['state'] = state;
              newSubmissionList['front_office_state'] = state;
            }
            return newSubmissionList;
          });
          setSubmissionLists(newSubmissionLists);
          if (!submissionListToSend)
            setShowPickUpSuccessPopup(true);
          else
            resetHomePickUpData();

          let addNewState = true;
          for (const s of statesForFilters)
            if (s.value === state) {
              addNewState = false;
              break;
            }
          if (addNewState)
            setStatesForFilters([ ...statesForFilters, { value: state }])
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }


  // Funzione che aggiorna una determinata submission list sull'interfaccia grafica
  const handleChangeSubmissionListParams = (submissionList) => {
    let newSubmissionLists = submissionLists.map((s) => {
      return s.id === submissionList.id ? { ...submissionList } : s
    });
    setSubmissionLists(newSubmissionLists)
  }


  // Funzione che aggiorna tutte le submission lists renderizzate sull'interfaccia grafica in corrispondenza
  // di un determinato parametro
  const handleChangeAllSubmissionLists = (key, value) => {
    let newSubmissionLists = submissionLists.map((s) => {
      const newSubmissionList = { ...s };
      newSubmissionList[key] = value;
      return newSubmissionList;
    });
    setSubmissionLists(newSubmissionLists)
  }


  // Funzione che gestisce l'espansione / compattamento di tutte le submission lists renderizzate sull'interfaccia grafica
  const handleExpandAll = () => {
    setExpandAll(!expandAll);
    handleChangeAllSubmissionLists('display_content', !expandAll);
  }


  // Funzione che verifica se la funzione di ritiro aggregato delle submission lists possa essere abilitato per
  // l'utente aggregatore
  const enableHomePickUpCollect = () => {
    return graderCompanies.length === 1 || isDefined(filters.grader_company_id);
  }



  
  

  return (
    <React.Fragment>
      <div className={`${isMiddleman ? 'position-relative overflow-hidden min-h-vh-100' : ''}`}>
        <div className={`${isMiddleman ? 'w-100 p-0 m-0 submission-lists-section-1' : ''}`}>
          {/*  HEADER DELLA PAGINA */}
          <div className="row d-block justify-content-center text-center bg-aig-gradient w-100 m-0 color-white py-4 border-bottom-radius-20px px-3 mb-5">
            <div>
              <h2><b>{I18n.t('js.common.submissionLists')}</b></h2>
            </div>
          </div>




          <div id="submission_lists_header_container">
            {/*  SEZIONE DEDICATA AI FILTRI DELLA PAGINA */}
            <div className="row mx-0 br-8px border-aiG-light-gray-imp bg-aiG-gray3-imp">
              <div className="col-12">
                <div className="row d-flex justify-content-between px-3 py-2">
                  <div className="w-50">
                    <div className="d-flex align-items-center justify-content-start text-left cursor-pointer"
                         onClick={(e) => setFiltersEnabled(!filtersEnabled)}>
                      <b>{I18n.t('js.filters.filters')}</b>
                      <img src={`/images/icons/black/arrow-${filtersEnabled ? 'up' : 'down'}.svg`} className="cursor-pointer ml-2"
                           alt="" width="10" height="10"
                      />
                    </div>
                  </div>

                  <div className="w-50">
                    <div className="d-flex align-items-center justify-content-end blue-label text-right cursor-pointer"
                         onClick={(e) => {
                           $('.select2-custom').val('').trigger('change.select2');
                           setFromDate(null);
                           setToDate(null);
                           updateFilters(initialFilters);
                         }}>
                      <img src="/images/icons/blue/refresh.svg" className="mr-2" id="reset"
                           alt="" width="15" height="15"
                      />
                      {I18n.t('js.filters.cancelFilters')}
                    </div>
                  </div>
                </div>


                <div className={`row slide-animation-container slide-${filtersEnabled ? 'down' : 'up'}`}>
                  <hr className="separator my-0 w-100" />

                  <div className="col-12 pr-0">
                    <div className="row w-100 py-2">
                      <div className="col-6 col-md-3 col-lg-2 mb-2 py-1">
                        <p className="mb-0 filter-label">{I18n.t('js.filters.placeholderOrderIdExtended')}</p>
                        <input
                          type="text"
                          value={filters.number ? filters.number : ""}
                          className={`form-control filter-input ${filters.number ? 'selected-label' : 'border-none'}`}
                          onChange={(e) => onChangeDebouncedFilterHandler('number', e.target.value)}
                          name="number_filter"
                          id="number_filter"
                        />
                      </div>

                      {
                        users && users.length > 1 &&
                          <div className="col-6 col-md-3 col-lg-2 mb-2 py-1">
                            <p className="mb-0 filter-label">{I18n.t('js.filters.userOwner')}</p>
                            <select
                              className="form-control filter-input select2-custom p-0"
                              value={filters.user_id ? filters.user_id : ""}
                              name="user_id"
                              id="user_id"
                              onChange={(e) => {}}
                            >
                              <option value=""></option>
                              {users.map(user => {
                                return <option value={user[1]} key={user[1]}>
                                  { parseUserGeneralities(user[0], user[3], user[2]) }
                                </option>
                              })}
                            </select>
                          </div>
                      }

                      {
                        subMiddlemen && subMiddlemen.length > 1 &&
                          <div className="col-6 col-md-3 col-lg-2 mb-2 py-1">
                            <p className="mb-0 filter-label">{I18n.t('js.filters.store')}</p>
                            <select
                              className="form-control filter-input select2-custom p-0"
                              value={filters.middleman_business_name ? filters.middleman_business_name : ""}
                              name="middleman_business_name"
                              id="middleman_business_name"
                              onChange={(e) => {}}
                            >
                              <option value=""></option>
                              {subMiddlemen.map(middleman => {
                                return <option value={middleman} key={middleman}>
                                  { middleman }
                                </option>
                              })}
                            </select>
                          </div>
                      }

                      <div className="col-6 col-md-3 col-lg-2 mb-2 py-1">
                        <p className="mb-0 filter-label">{I18n.t('js.filters.title')}</p>
                        <input
                          type="text"
                          defaultValue={filters.title ? filters.title : ""}
                          className={`form-control filter-input ${filters.title ? 'selected-label' : 'border-none'}`}
                          onChange={(e) => onChangeDebouncedFilterHandler('title', e.target.value)}
                          name="title_filter"
                          id="title_filter"
                        />
                      </div>

                      <div className="col-6 col-md-3 col-lg-2 mb-2 py-1">
                        <p className="mb-0 filter-label">{I18n.t('js.filters.state')}</p>
                        <select
                          className={`form-control filter-input ${filters.state ? 'selected-label' : 'border-none'} pl-2`}
                          value={filters.state ? filters.state : ""}
                          name="state_filter"
                          id="state_filter"
                          onChange={(e) => getSubmissionListsByMatchingFilters('state', e.target.value)}
                        >
                          <option value={""}></option>
                          {statesForFilters.map((state) => (
                            <option value={state.value} key={state.value}>
                              {parseSubmissionListState(state.value)}
                            </option>
                          ))}
                        </select>
                      </div>

                      {
                        graderCompanies.length > 1 &&
                        <div className="col-6 col-md-3 col-lg-2 mb-2 py-1">
                          <p className="mb-0 filter-label">{I18n.t('js.filters.graderCompany')}</p>
                          <select
                            className={`form-control filter-input ${filters.grader_company_id ? 'selected-label' : 'border-none'} pl-2`}
                            value={filters.grader_company_id ? filters.grader_company_id : ""}
                            name="grader_company_id_filter"
                            id="grader_company_id_filter"
                            onChange={(e) => getSubmissionListsByMatchingFilters('grader_company_id', e.target.value)}
                          >
                            <option value=""></option>
                            {graderCompanies.map(company => {
                              return <option value={company.id} key={company.id}>
                                {company.meta_name}
                              </option>
                            })}
                          </select>
                        </div>
                      }

                      <div className="col-6 col-md-3 col-lg-2 mb-2 py-1">
                        <p className="mb-0 filter-label">{I18n.t('js.filters.FromDate')}</p>
                        <div className="d-flex">
                          <DatePicker
                            locale={setLocaleInDataPiker()}
                            wrapperClassName="custom-date-picker"
                            className={`form-control filter-input ${fromDate ? 'selected-label' : 'border-none'}`}
                            selected={fromDate}
                            name="from_confirmed_at_filter"
                            id="from_confirmed_at_filter"
                            onChange={date => {
                              setFromDate(date);
                              getSubmissionListsByMatchingFilters("from_confirmed_at", date);
                            }}
                            withPortal
                          />
                          {
                            fromDate &&
                            <button
                              type="button"
                              className="btn list-icon p-0 ml-2"
                              onClick={(e) => {
                                setFromDate(null);
                                getSubmissionListsByMatchingFilters("from_confirmed_at", null);
                              }}>
                              <i className="fas fa-backspace"/>
                            </button>
                          }
                        </div>
                      </div>

                      <div className="col-6 col-md-3 col-lg-2 mb-2 py-1 pr-3 pr-lg-0">
                        <p className="mb-0 filter-label">{I18n.t('js.filters.ToDate')}</p>
                        <div className="d-flex">
                          <DatePicker
                            locale={setLocaleInDataPiker()}
                            wrapperClassName="custom-date-picker"
                            className={`form-control filter-input ${toDate ? 'selected-label' : 'border-none'}`}
                            selected={toDate}
                            name="to_confirmed_at_filter"
                            id="to_confirmed_at_filter"
                            onChange={date => {
                              setToDate(date);
                              getSubmissionListsByMatchingFilters('to_confirmed_at', date)
                            }}
                            withPortal
                          />
                          {
                            toDate &&
                            <button
                              type="button"
                              className="btn list-icon p-0 ml-2"
                              onClick={(e) => {
                                setToDate(null);
                                getSubmissionListsByMatchingFilters("to_confirmed_at", null);
                              }}>
                              <i className="fas fa-backspace"/>
                            </button>
                          }
                        </div>
                      </div>

                      <div className="col-6 col-md-3 col-lg-2 mb-2 py-1">
                        <p className="mb-0 filter-label">{I18n.t('js.filters.serialNumber')}</p>
                        <input
                          type="text"
                          defaultValue={filters.serial_number ? filters.serial_number : ""}
                          className={`form-control filter-input ${filters.serial_number ? 'selected-label' : 'border-none'}`}
                          onChange={(e) => onChangeDebouncedFilterHandler('serial_number', e.target.value)}
                          name="serial_number_filter"
                          id="serial_number_filter"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>




            {/*  SEZIONE DEDICATA ALLA GESTIONE DEI RISULTATI RENDERIZZATI SULLA PAGINA */}
            <div className="mb-3 mt-4 d-block d-sm-flex justify-content-start justify-content-sm-between align-items-center border-bottom-2px-lightgray3">
              <div className="d-flex justify-content-between align-items-center pb-3 px-0">
                <div className="align-items-center">
                  <b>{submissionListsCount}</b>&nbsp;
                  {pluralize(submissionListsCount, 'editSubmissionListPage.submission').toLowerCase()}
                </div>

                {

                  initCompleted && submissionListsCount > 0 &&
                    <div className="d-flex d-sm-none align-items-center">
                      <Expander
                        expandAll={expandAll}
                        handleExpandAll={handleExpandAll}
                      />
                    </div>
                }
              </div>

              {
                initCompleted && submissionListsCount > 0 &&
                  <div className="d-flex justify-content-start justify-content-sm-end pb-3 px-0">
                    <div className="d-none d-sm-flex align-items-center">
                      <Expander
                        expandAll={expandAll}
                        handleExpandAll={handleExpandAll}
                      />
                    </div>

                    <select
                      className={`form-control minW-125px gray-label d-none d-md-flex ${viewMode ? 'selected-label' : ''} mx-3`}
                      name="view_as"
                      id="view_as"
                      value={viewMode ? viewMode : ''}
                      onChange={(e) => {
                        setViewMode(e.target.value);
                        setSubmissionListsAnimationDivider(Number.MAX_SAFE_INTEGER);
                      }}>
                      <option value="" disabled hidden>{I18n.t('js.filters.viewMode.viewAs')}</option>
                      {['list', 'grid'].map(option => {
                        return <option value={option} key={option}>
                          {I18n.t(`js.filters.viewMode.${option}`)}
                        </option>
                      })}
                    </select>

                    <select
                      className={`form-control ${isSuperMiddleman ? 'minW-220px' : 'minW-165px'} gray-label ${filters.sort_by ? 'selected-label' : ''}`}
                      name="sort_by"
                      id="sort_by"
                      value={filters.sort_by ? filters.sort_by : ''}
                      onChange={(e) => getSubmissionListsByMatchingFilters('sort_by', e.target.value)}>
                      <option value="" disabled hidden>{I18n.t('js.indexSubmissionListsPage.sortBy')}</option>
                      {sorting_options.filter(option => !['state', 'middleman'].includes(option.value)).map(option => {
                        return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                      })}
                      <option disabled>___________________</option>
                      {sorting_options.filter(option => ['state', 'middleman'].includes(option.value)).map(option => {
                        return <option value={option.value} key={option.value}>{I18n.t(option.locale)}</option>
                      })}
                    </select>

                    {
                      filters.sort_by &&
                        <div className="d-flex justify-content-center align-items-center px-0 cursor-pointer ml-3"
                             onClick={(e) => getSubmissionListsByMatchingFilters('sorting_direction', filters.sorting_direction === 'desc' ? 'asc' : 'desc')}>
                          <div className="d-flex justify-content-center align-items-center blue-label minW-38px">
                            <p className="my-0 mr-2">
                              { filters.sorting_direction === 'desc' ? '↓' : '↑' }
                            </p>
                            <p className="my-0">
                              { I18n.t(`js.filters.sort.${filters.sorting_direction}endingSuperCompact`) }
                            </p>
                          </div>
                        </div>
                    }
                  </div>
              }
            </div>
          </div>




          {/*  SEZIONE DEDICATA ALL'ELENCO DI TUTTE LE SUBMISSION LISTS' */}
          <div id="submission_lists_container">
            {
              (loading || changeViewMode) ?
                <div className="d-flex justify-content-center my-5">
                  <div className="d-flex align-items-center text-intense-blue text-weight-500">
                    <div className="spinner-border" role="status"/>
                    <b className="ml-2">{I18n.t('js.indexSubmissionListsPage.loading')}</b>
                  </div>
                </div>
              :
                submissionLists.length > 0 ?
                  <BottomScrollListener onBottom={!isMiddleman ? getSubmissionLists : () => {}}>
                    <SubmissionListsList
                      submissionLists={submissionLists}
                      setSubmissionLists={setSubmissionLists}
                      isMiddleman={isMiddleman}
                      isSuperMiddleman={isSuperMiddleman}
                      viewMode={viewMode}
                      handleDelete={openDeletePopup}
                      enableHomePickUpCollect={enableHomePickUpCollect()}
                      addSubmissionListToRequestPickUp={addSubmissionListToRequestPickUp}
                      submissionListsAnimationDivider={submissionListsAnimationDivider}
                      displayAll={true}
                      setShowErrorModal={setShowErrorModal}
                    />




                    {
                      !hasLoadedAllSubmissionLists && submissionLists.length > 0 &&
                        <div className="d-flex justify-content-center mb-5  mt-0">
                          {
                            (!isMiddleman || loadingMore) ?
                              <div className="d-flex align-items-center text-intense-blue text-weight-500">
                                <div className="spinner-border" role="status"/>
                                <b className="ml-2">{I18n.t('js.indexSubmissionListsPage.loading')}</b>
                              </div>
                            :
                              !loadingMore &&
                                <div className="d-flex align-items-center cursor-pointer" onClick={() => {
                                  setLoadingMore(true);
                                  getSubmissionLists();
                                }}>
                                  <span className="text-intense-blue text-weight-500 pt-1">
                                    {I18n.t('js.common.loadMore')}
                                  </span>
                                </div>
                          }
                        </div>
                    }
                  </BottomScrollListener>
                  :
                  <div className="d-flex justify-content-center">
                    <div className="d-flex align-items-center text-muted ml-md-3 mr-md-3 mt-md-4 text-center text-space">
                      <b className="ml-2">{I18n.t('js.filters.noResultsFoundSubmissionList')}</b>
                    </div>
                  </div>
            }
          </div>
        </div>




        {/*  SEZIONE DEDICATA ALLE FUNZIONI RIVOLTE ALL'AGGREGATORE */}
        {
          isMiddleman &&
          <div className="row mx-0 br-8px border-aiG-light-gray-imp bg-aiG-gray3-imp" id="submission_lists_footer">
            <div className="col-12">
              <div className="row d-flex justify-content-start align-items-center px-3 py-2">
                <input
                  type="checkbox"
                  className={`filter-checkbox--size select-all-submission-lists-checkbox ${checkAll ? (checkNotCheckedSubmissionLists() ? 'partial-submission-lists-checked' : 'all-submission-lists-checked') : ''} mr-2`}
                  id="select_all_submission_lists"
                  disabled={!enableHomePickUpCollect()}
                  defaultChecked={checkAll}
                  onClick={() => handleSelectAllSubmissionLists(!checkAll)}
                />

                <label htmlFor="select_all_submission_lists" className="text-intense-blue text-weight-500 pt-2 cursor-pointer">
                  {I18n.t('js.indexSubmissionListsPage.selectAllConfirmedSubmissionlists')}
                </label>
              </div>

              <div className="row">
                <hr className="separator my-0 w-100" />

                <div className="col-12 col-sm-6 d-flex justify-content-start align-items-center py-2">
                  <span className="text-weight-500">
                    { I18n.t('js.indexSubmissionListsPage.ifSelected') }:
                  </span>
                  <button id="request_home_pick_up"
                          name="request_home_pick_up"
                          className="submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none ml-2"
                          disabled={submissionListsToRequestPickUp.length === 0}
                          onClick={() => setShowPickUpRequestPopup(true)}
                  >
                    { I18n.t('js.indexSubmissionListsPage.requestPickUp_3').toUpperCase() }
                  </button>
                </div>

                <div className="col-12 col-sm-6 d-flex justify-content-start justify-content-sm-end align-items-center pr-3 py-2">
                  <PDFGenerator
                    type={'button'}
                    generatorText={I18n.t('js.editOrderPage.printOrder').toUpperCase()}
                    cssClassList={"submission_lists_footer_button bg-intense-blue-imp color-white text-weight-500 border-none"}
                    dataToPrint={{ filters:filters, users: users, graderCompanies: graderCompanies, userId: userId, companyPoint: companyPoint, isSuperMiddleman: isSuperMiddleman }}
                    useTemplate={'submissionLists'}
                    setShowErrorModal={setShowErrorModal}
                    customImageIcon={window.location.origin + `/images/icons/white/download-pdf.svg`}
                    spinnerCssClassList={'maxH-17px max-w-17px'}
                    downloadMsgCssClassList={'text-uppercase'}
                  />
                </div>
              </div>
            </div>
          </div>
        }
      </div>





      <AlertPopup
        showAlertPopup={showDeletePopup}
        onSuccess={onDeleteHandler}
        onDiscard={setShowDeletePopup}
        popupTitle={`${I18n.t('js.indexSubmissionListsPage.alertPopupDeleteSubmissionListTitle')}`}
        popupContent={`${I18n.t('js.indexSubmissionListsPage.alertPopupDeleteSubmissionListContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.delete').toUpperCase()}`}
      />

      {
        showPickUpRequestPopup &&
          <SubmissionListHomePikcUpPopup
            showPickUpRequestPopup={showPickUpRequestPopup}
            onShipmentManagementHandler={onShipmentManagementHandler}
            onCancel={() => { setSubmissionListToSend(null); setShowPickUpRequestPopup(false) }}
            setShowPickUpRequestPopup={setShowPickUpRequestPopup}
            submissionListToSend={submissionListToSend}
            productsCountToRequestPickUp={productsCountToRequestPickUp}
            companyToRequestPickUp={companyToRequestPickUp}
            graderCompanyShipmentAddress={graderCompanyShipmentAddress}
            homePickUpFavoriteDay={homePickUpFavoriteDay}
            setHomePickUpFavoriteDay={setHomePickUpFavoriteDay}
            homePickUpFavoriteHour={homePickUpFavoriteHour}
            setHomePickUpFavoriteHour={setHomePickUpFavoriteHour}
            homePickUpDates={homePickUpDates}
            currentUserGenerality={currentUserGenerality}
          />
      }

      <AlertPopup
        showAlertPopup={showPickUpSuccessPopup}
        onSuccess={resetHomePickUpData}
        onCancel={resetHomePickUpData}
        popupTitle={homePickUpFavoriteDay ? `${I18n.t('js.indexSubmissionListsPage.homePickUpCollect.title')}!` : ''}
        customHtmlPopupContent={
          `${
            homePickUpFavoriteDay ?
              `<div class="w-100 m-0 p-0">
                <p>${I18n.t('js.indexSubmissionListsPage.homePickUpCollect.text1')} ${companyToRequestPickUp?.meta_name}.</p>
                <p>${I18n.t('js.indexSubmissionListsPage.homePickUpCollect.text2')}:</p>
                <div>
                  <ol class="ml-4">
                    <li class="my-1">${I18n.t('js.indexSubmissionListsPage.homePickUpCollect.text3')}.</li>
                    <li class="my-1">${I18n.t('js.indexSubmissionListsPage.homePickUpCollect.text4')}.</li>
                    <li class="my-1">${I18n.t('js.indexSubmissionListsPage.homePickUpCollect.text5')}.</li>
                    <li class="my-1">${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text12')}</li>
                    <li class="my-1">${I18n.t('js.indexSubmissionListsPage.homePickUpCollect.text7')}.</li>
                    <li class="my-1">${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5_2')} ${parseHomePickUpFavoriteDay(homePickUpFavoriteDay)} ${homePickUpFavoriteHour && homePickUpFavoriteHour.toLowerCase() !== 'all_day' ? I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5_3') + ' ' + parseHomePickUpFavoriteHour(homePickUpFavoriteHour) : ''} ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.instructions.text5_4')} ${companyToRequestPickUp?.meta_name}.</li>
                    <li class="my-1">${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text17')} ${companyToRequestPickUp?.meta_name} ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text18_1')} ${I18n.t('js.editSubmissionListPage.webComponent.confirmation.text18_2')}</li>
                  </ol>
                </div>
              </div>`
            :
              `<p>${I18n.t('js.indexSubmissionListsPage.homePickUpCollect.text8')} ${companyToRequestPickUp?.meta_name}.</p>
               <p>${I18n.t('js.indexSubmissionListsPage.homePickUpCollect.text9')}.</p>`
          }`
        }
        confirmButtonText={`${I18n.t('js.common.ok').toUpperCase()}`}
      />

      <SuccessFlashMessage
        showSuccessFlashMessage={showSuccessFlashMessage}
        setShowSuccessFlashMessage={setShowSuccessFlashMessage}
      />

      <ErrorModal
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
      />

      <SuccessModal
        showSuccessModal={showSuccessModal}
        setShowSuccessModal={setShowSuccessModal}
      />
    </React.Fragment>
  );
};

export default IndexSubmissionLists;